const systemBanner = {
  admin: {
    enabled: 'Show banner',
    level: 'Severity',
    level_info: 'Information',
    level_warning: 'Warning',
    level_critical: 'Critical',
    template: 'Template',
    template_params: 'Template parameters',
    template_params_hint:
      'Values you enter here replace {{placeholders}} in the selected message template.',
    preview: 'Preview (current language)',
  },
  validation: {
    invalid_template: 'The selected template is no longer available.',
    template_required: 'Choose a template.',
    invalid_datetime: 'Enter a valid date and time.',
    invalid_number: 'Enter a valid number.',
  },
};

export default systemBanner;
